module.exports = __webpack_public_path__ + "img/changeWidth-1@2x.2f6d8ca.webp";